var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container py-4 py-lg-5 my-lg-5 px-4 px-sm-0" },
    [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-xl-10" }, [
          _c(
            "h2",
            { staticClass: "fs-xxl fw-500 mt-4 text-white text-center mb-2" },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.__t(_vm.main_title)) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "h5 fw-300 mb-5 text-white opacity-60 text-center" },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.__t(_vm.main_description)) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-center" }, [
            _c("div", { staticClass: "col-xl-7 col-lg-8 col-md-10" }, [
              _c(
                "div",
                {
                  staticClass:
                    "card register-card shadow-lg border-0 rounded-plus",
                },
                [
                  _c("div", { staticClass: "card-body p-4 p-lg-5" }, [
                    _c("div", { staticClass: "form-group mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label fw-500",
                          attrs: { for: "email" },
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.__t("EMAIL")) +
                              "\n                                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.user_form.email,
                            expression: "user_form.email",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "form-control form-control-lg",
                        class: { "is-invalid": _vm.errors.email },
                        attrs: {
                          id: "email",
                          type: "email",
                          placeholder: "example@email.com",
                          autocomplete: "email",
                        },
                        domProps: { value: _vm.user_form.email },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.user_form,
                              "email",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.email
                        ? _c(
                            "div",
                            { staticClass: "invalid-feedback d-block" },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.errors.email) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group mb-4" },
                      [
                        _c("label", { staticClass: "form-label fw-500" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.__t("PHONE")) +
                              "\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("vue-tel-input", {
                          staticClass: "tel-input-custom",
                          attrs: {
                            mode: "international",
                            "dropdown-options": {
                              showDialCodeInList: true,
                              showFlags: true,
                            },
                            "input-options": _vm.telInputOptions,
                            "valid-characters-only": true,
                            "auto-default-country": true,
                            "preferred-countries": [
                              "ua",
                              "pl",
                              "de",
                              "gb",
                              "us",
                              "ka",
                              "ge",
                            ],
                          },
                          on: { input: _vm.onPhoneInput },
                          model: {
                            value: _vm.user_form.phone,
                            callback: function ($$v) {
                              _vm.$set(_vm.user_form, "phone", $$v)
                            },
                            expression: "user_form.phone",
                          },
                        }),
                        _vm._v(" "),
                        _vm.errors.phone
                          ? _c(
                              "div",
                              { staticClass: "invalid-feedback d-block" },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.errors.phone) +
                                    "\n                                "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label fw-500",
                          attrs: { for: "name" },
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.__t("NAME")) +
                              "\n                                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.user_form.name,
                            expression: "user_form.name",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "form-control form-control-lg",
                        class: { "is-invalid": _vm.errors.name },
                        attrs: {
                          id: "name",
                          type: "text",
                          placeholder: _vm.__t("U.NAME"),
                          autocomplete: "name",
                        },
                        domProps: { value: _vm.user_form.name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.user_form,
                              "name",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.name
                        ? _c(
                            "div",
                            { staticClass: "invalid-feedback d-block" },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.errors.name) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label fw-500",
                          attrs: { for: "restaurant" },
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.__t("BRAND_NAME")) +
                              "\n                                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.user_form.brand,
                            expression: "user_form.brand",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "form-control form-control-lg",
                        class: { "is-invalid": _vm.errors.brand },
                        attrs: {
                          id: "restaurant",
                          type: "text",
                          placeholder: _vm.__t("BRAND_NAME"),
                        },
                        domProps: { value: _vm.user_form.brand },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.user_form,
                              "brand",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.brand
                        ? _c(
                            "div",
                            { staticClass: "invalid-feedback d-block" },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.errors.brand) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label fw-500",
                          attrs: { for: "password" },
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.__t("PASSWORD")) +
                              "\n                                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.user_form.password,
                            expression: "user_form.password",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "form-control form-control-lg",
                        class: { "is-invalid": _vm.errors.password },
                        attrs: {
                          id: "password",
                          type: "password",
                          placeholder: _vm.__t("PASSWORD"),
                          autocomplete: "new-password",
                        },
                        domProps: { value: _vm.user_form.password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.user_form,
                              "password",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.password
                        ? _c(
                            "div",
                            { staticClass: "invalid-feedback d-block" },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.errors.password) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group mb-4" }, [
                      _c(
                        "label",
                        { staticClass: "form-label fw-500 d-block" },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.__t("NUMBER_LOCATIONS")) +
                              "\n                                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pill-group" },
                        _vm._l(_vm.locationOptions, function (item) {
                          return _c(
                            "label",
                            {
                              key: item.value,
                              staticClass: "pill-option",
                              class: {
                                active: _vm.user_form.locations === item.value,
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.user_form.locations,
                                    expression: "user_form.locations",
                                  },
                                ],
                                staticClass: "pill-input",
                                attrs: { type: "radio" },
                                domProps: {
                                  value: item.value,
                                  checked: _vm._q(
                                    _vm.user_form.locations,
                                    item.value
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.user_form,
                                      "locations",
                                      item.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.label))]),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.errors.locations
                        ? _c(
                            "div",
                            { staticClass: "invalid-feedback d-block" },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.errors.locations) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-end pt-2" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-outline-primary btn-lg px-5 waves-effect waves-themed",
                            attrs: {
                              disabled: _vm.is_loading || !_vm.form_valid,
                            },
                            on: { click: _vm.make_register },
                          },
                          [
                            !_vm.is_loading
                              ? _c("span", [_vm._v(_vm._s(_vm.__t("NEXT")))])
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.__t("LOADING")) + "..."),
                                ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }